import React from 'react';
import { Offline, Online } from 'react-detect-offline';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import About from '../components/layouts/About';
import Footer from '../components/layouts/Footer';
import Home from '../components/layouts/Home';
import NavBar from '../components/layouts/NavBar';
import OfflinePage from '../components/layouts/OfflinePage';
import store from '../redux/store';
import Application from '../components/application/Application';
import MyApplication from '../components/application/MyApplication';
import Contact from '../components/layouts/Contact';
import FindAccount from '../components/auth/FindAccount';
import NotFound from '../components/Results/NotFound';
import ResetPassword from '../components/auth/ResetPassword';
import Success from '../components/layouts/Success';
import ConfirmAccount from '../components/auth/ConfirmAccount';
import Landing from '../components/layouts/Landing';
import Dashboard from '../components/admins/Dashboard';
import Users from '../components/admins/Users';
import ViewApplication from '../components/admins/ViewApplication';
import SpecificApplication from '../components/admins/SpecificApplication';
import ApplicationView from 'views/Applications';
import SpecificApplicationView from 'views/Applications/SpecificApplication';
import BankHome from 'views/Banks';
import { ProtectedRoute } from './Router';
import { ErrorBoundary } from 'react-error-boundary';
import ServerError from '../components/Results/ServerError';
import TermsAndConditions from 'views/legal/TermsAndConditions.js';
import { useIdleTimer } from 'react-idle-timer';
import { logout, isUserAuthenticated } from 'utils';
import VerifyEmail from 'components/application/ChangeEmail';

const AppRoute = ({ darkMode, setDarkMode }) => {
  const idleTimeout = process.env.REACT_APP_IDLE_TIMEOUT;

  useIdleTimer({
    timeout: idleTimeout,
    onIdle: () => {
      if (isUserAuthenticated()) {
        logout();
      }
    },
  });

  return (
    <Router>
      <Provider store={store}>
        <ErrorBoundary
          FallbackComponent={ServerError}
          onReset={() => {
            // reset the state of the app so the error doesn't happen again
          }}
        >
          <div className='App'>
            <NavBar darkMode={darkMode} setDarkMode={setDarkMode} />
            <div>
              <Switch>
                <Route exact path='/' component={Landing} />
                <Route exact path='/auth' component={Home} />
                <Route exact path='/about' component={About} />
                <Route
                  exact
                  path='/support/legal-information'
                  component={TermsAndConditions}
                />
                <Route exact path='/find-account' component={FindAccount} />
                <Route exact path='/reset' component={ResetPassword} />
                <Route exact path='/success' component={Success} />
                <Route exact path='/confirm' component={ConfirmAccount} />
                <Route exact path='/application' component={Application} />
                <ProtectedRoute
                  allowedRoles={['Applicant']}
                  path='/email-change'
                  component={VerifyEmail}
                />
                <ProtectedRoute
                  exact
                  allowedRoles={['Applicant']}
                  path='/my/application'
                  component={MyApplication}
                />

                {/* BACKEND ROUTES */}
                <ProtectedRoute
                  exact
                  allowedRoles={['Back-End Officer', 'Admin']}
                  path='/loan/applications'
                  component={ApplicationView}
                />
                <ProtectedRoute
                  exact
                  allowedRoles={['Back-End Officer', 'Bank Officer']}
                  path='/loan/applications/:applicationId'
                  component={SpecificApplicationView}
                />

                <ProtectedRoute
                  exact
                  allowedRoles={['Bank Officer']}
                  path='/bank'
                  component={BankHome}
                />

                {/* ADMIN ROUTES */}
                <ProtectedRoute
                  exact
                  allowedRoles={['Admin', 'Super Admin', 'Back-End Officer']}
                  path='/users'
                  component={Users}
                />
                <ProtectedRoute
                  exact
                  allowedRoles={['Admin', 'Super Admin']}
                  path='/applications'
                  component={ApplicationView}
                />
                <ProtectedRoute
                  exact
                  allowedRoles={['Admin', 'Super Admin']}
                  path='/applications/:applicationId'
                  component={SpecificApplicationView}
                />
                <Route component={NotFound} />
              </Switch>
            </div>
            <Footer />
          </div>
        </ErrorBoundary>
      </Provider>
    </Router>
  );
};

export default AppRoute;
